import $ from 'jquery';

import ThemeBase from '../ThemeBase';
import Zoom from '../global/Zoom';

/* Polyfil template.content for IE11 */
const templateContent = (template) => {
  if('content' in template) {
    return document.importNode(template.content, true);
  } else {
    const fragment = document.createDocumentFragment();
    const children = template.childNodes;
    for (let i = 0; i < children.length; i++) {
      fragment.appendChild(children[i].cloneNode(true));
    }
    return fragment;
  }
}

export default class Media {
  /**
     *
     * @param {ThemeBase} theme
     * @param {HTMLElement} parent
     * @param {HTMLElement} targetElement
     * @param {boolean} autoload
     */
  constructor(theme, parent, targetElement, autoload) {
    this.theme = theme;
    this.parent = parent;
    this.media_id = parent.dataset.mediaId;
    this.type = parent.dataset.mediaType;
    this.loaded = false;
    this.active = false;
    this.plyrController = null;
    this.modelController = null;
    this.youtubeController = null;
    this.vimeoController = null;
    this.targetElement = targetElement;
    this.mediaWrapper = null;
    this.mediaUrl = null;
    this.selected = this.parent.classList.contains('product-single__thumbnail--selected');
    if (this.selected && autoload) {
      this.load();
    }
  }

    isMobile = () => {
      return window.matchMedia('screen and (max-width: 767px)').matches;
    }

    load = () => {
      return new Promise((resolve) => {
        if (this.loaded) {
          resolve();
          return;
        }
        const template = this.parent.querySelector('template');
        if (!template) {
          this.onLoad();
          resolve();
          return;
        }
        const fragment = templateContent(template);
        const oldMedia = this.targetElement.querySelector('[data-media-id="' + this.media_id + '"]');
        if (oldMedia) {
          try {
            this.targetElement.removeChild(oldMedia);
          } catch (e) {
            console.error(e);
          }
        }
        if (template.parentNode === this.targetElement) {
          this.targetElement.insertBefore(fragment, template);
        } else {
          this.targetElement.appendChild(fragment);
        }

        this.mediaWrapper = this.targetElement.querySelector('[data-media-id="' + this.media_id + '"]');
        if (this.selected) {
          this.mediaWrapper.classList.add('product-single__media--selected');
        }

        switch (this.type) {
          case 'model':
            window.Shopify.loadFeatures([
              {
                name: 'model-viewer-ui',
                version: '1.0',
              },
            ], () => {
              this.modelController = new window.Shopify.ModelViewerUI(this.mediaWrapper.querySelector('model-viewer'));

              // Don't interact with the rest of the page when model is not disabled
              this.modelController.viewer.parentElement.addEventListener('mouseup', (e) => {
                e.stopPropagation = function () {};
              }, { capture: true });

              // Prevent activating the viewer right after it was paused when clicked in position of the button
              this.modelController.elements.controlButton.addEventListener('click', (e) => {
                e.stopImmediatePropagation();
              }, { capture: true });

              this.modelController.viewer.addEventListener('shopify_model_viewer_ui_toggle_pause', this.onPause);
              this.modelController.viewer.addEventListener('shopify_model_viewer_ui_toggle_play', this.onPlay);

              this.onLoad();
              resolve();
            });
            break;
          case 'video':
            window.Shopify.loadFeatures([
              {
                name: 'video-ui',
                version: '1.0',
                onLoad: () => {
                  const video = this.mediaWrapper.querySelector('video');
                  const loop = (/** @type HTMLElement */ (video.parentNode)).dataset.videoLoop === 'true';
                  this.plyrController = new window.Shopify.Plyr(video, {
                    loop: {
                      active: loop,
                    },
                    focusOnPlay: false,
                  });
                  video.addEventListener('play', this.onPlay);
                  video.addEventListener('pause', this.onPause);
                  video.addEventListener('ended', this.onPause);

                  this.onLoad();
                  resolve();
                },
              },
            ]);
            break;
          case 'external_video':
            this.mediaUrl = this.mediaWrapper.querySelector('iframe');
            if (this.mediaUrl) this.mediaUrl = this.mediaUrl.src;
            
            //Is the video source Youtube or Vimeo?
            if (this.mediaUrl.includes('vimeo')) {
              this.theme.loadVimeoApi().then(() => {
                const iframe = this.mediaWrapper.querySelector('iframe');
                const loop = (/** @type HTMLElement */ (iframe.parentNode)).dataset.videoLoop === 'true';
                const player = new window.Vimeo.Player(iframe);
                player.ready().then(() => {
                  this.vimeoController = player;
                  this.onLoad();
                  resolve();
                }).catch((err) => console.log(err));
  
                player.on('play', () => {
                  this.onPlay();
                });
  
                player.on('pause', () => {
                  this.onPause();
                });
  
                player.on('finish', () => {
                  if (loop) {
                    player.play();
                  } else {
                    this.onPause();
                  }
                });
              });
            } else if (this.mediaUrl.includes('youtube')) {
              this.theme.loadYoutubeApi().then(() => {
                const iframe = this.mediaWrapper.querySelector('iframe');
                const loop = (/** @type HTMLElement */ (iframe.parentNode)).dataset.videoLoop === 'true';
                new window.YT.Player(iframe, {
                  events: {
                    onReady: (event) => {
                      this.youtubeController = /** @type {import('../window').YoutubePlayer} */ (event.target);
                      this.onLoad();
                      resolve();
                    },
                    onStateChange: (event) => {
                      if (event.data === window.YT.PlayerState.PLAYING) {
                        this.onPlay();
                      } else if (event.data === window.YT.PlayerState.PAUSED) {
                        this.onPause();
                      } else if (event.data === window.YT.PlayerState.ENDED) {
                        if (loop) {
                          this.youtubeController.playVideo();
                        } else {
                          this.onPause();
                        }
                      }
                    },
                    onError: (event) => {
                      console.warn('Youtube video error', event, event.data);
                      this.onPause();
                    },
                  }
                });
              });
            }
            break;
          case 'image':
            this.mediaWrapper.querySelector('.product-single__media img').addEventListener('load', () => {
              if (this.parent.dataset.imageZoomEnable === 'true' && !this.isMobile()) {
                new Zoom(this.theme, this.mediaWrapper.querySelector('.product-single__media__image'));
              }
              this.onLoad();
              resolve();
            });
            break;
          default:
            this.onLoad();
            resolve();
        }
      });
    };

    onLoad = () => {
      if(!this.mediaWrapper.parentNode) return;
      this.loaded = true;
      (/** @type HTMLElement */ (this.mediaWrapper.parentNode)).classList.add('product-single__media--loaded');
      const e = new CustomEvent('media-load', {
        detail: {
          parent: this.parent,
          media: this,
        },
      });
      this.parent.dispatchEvent(e);
      if (window.ShopifyXR && window.ShopifyXR.setupXRElements) {
        window.ShopifyXR.setupXRElements();
      }
    }

    play = () => {
      if (!this.loaded) {
        this.load().then(this._play);
      } else {
        this._play();
      }
    };

    _play = () => {
      switch (this.type) {
        case 'model':
          this.modelController.play();
          this.onPlay();
          break;
        case 'video':
          this.plyrController.play().then(this.onPlay).catch(console.warn);
          break;
        case 'external_video':
          if (this.mediaUrl.includes('vimeo')) {
            this.vimeoController.play();
          } else if (this.mediaUrl.includes('youtube')) {
            this.youtubeController.playVideo();
          }
          this.onPlay();
          break;
      }
    };

    onPlay = () => {
      this.active = true;
      this.mediaWrapper.classList.add('product-single__media--active');
      if (!this.loaded) {
        this.loaded = true;
        (/** @type HTMLElement */ (this.mediaWrapper.parentNode)).classList.add('product-single__media--loaded');
      }
      const e = new CustomEvent('media-play', {
        detail: {
          parent: this.parent,
          media: this,
        },
      });
      this.parent.dispatchEvent(e);

      if (document.activeElement === document.body) {
        // No element has focus, focus this media
        this.focus();
      }
    };

    autoplay = () => {
      if ($(window).width() > 768) {
        this.play();
      }
    };

    pause = () => {
      if (!this.active) {
        return;
      }
      switch (this.type) {
        case 'model':
          break;
        case 'video':
          this.plyrController.pause();
          break;
        case 'external_video':
          if (this.mediaUrl.includes('vimeo')) {
            this.vimeoController.pause();
          } else if (this.mediaUrl.includes('youtube')) {
            this.youtubeController.pauseVideo();
          }
          break;

      }
      this.onPause();
    };

    togglePlay = () => {
      if (this.active) {
        this.pause();
      } else {
        this.play();
      }
    }

    onPause = () => {
      this.active = false;
      this.mediaWrapper.classList.remove('product-single__media--active');
      const e = new CustomEvent('media-pause', {
        detail: {
          parent: this.parent,
          media: this,
        },
      });
      this.parent.dispatchEvent(e);
    };

    select = () => {
      this.selected = true;
      if (this.mediaWrapper) {
        this.mediaWrapper.classList.add('product-single__media--selected');
      }
    }

    deselect = () => {
      if (this.selected) {
        this.selected = false;
        if (this.mediaWrapper) {
          this.mediaWrapper.classList.remove('product-single__media--selected');
        }
      }
    }

    reattach = (newTarget) => {
      this.targetElement = newTarget;
      if (this.mediaWrapper) {
        newTarget.appendChild(this.mediaWrapper);
        if (this.selected) {
          newTarget.classList.add('product-single__media--selected');
        } else {
          newTarget.classList.remove('product-single__media--selected');
        }
      }
    }

    scrollIntoView = (element) => {
      requestAnimationFrame(function () {
        const stickyHeaderHeight = $('.sticky-header-wrapper').height() || 0;
        const y = element.getBoundingClientRect().top + window.pageYOffset - stickyHeaderHeight;
        window.scrollTo(0, y);
      });
    }

    focus = () => {
      switch (this.type) {
        case 'video': {
          const plyr = /** @type HTMLElement */ (this.mediaWrapper.querySelector('.plyr'));
          if (plyr) {
            this.scrollIntoView(plyr);
            plyr.focus();
          }
          break;
        }
        case 'model': {
          const viewer = /** @type HTMLElement */ (this.mediaWrapper.querySelector('model-viewer'));
          if (viewer && viewer.shadowRoot) {
            this.scrollIntoView(viewer);
            viewer.focus();
          } else {
            // Not yet loaded, try later
            setTimeout(this.focus, 1000);
          }
          break;
        }
        case 'external_video': {
          const iframe = this.mediaWrapper.querySelector('iframe');
          this.scrollIntoView(iframe);
          iframe.focus();
          iframe.contentWindow.focus();
          break;
        }
        default: {
          if (this.mediaWrapper) {
            this.scrollIntoView(this.mediaWrapper);
            (/** @type HTMLElement */ (this.mediaWrapper)).focus();
          }
        }
      }
    }

    destroy = () => {
    };
}